export const meses = [
  { short: 'En', long: 'Enero', cell: 'E', index: 0 },
  { short: 'Feb', long: 'Febrero', cell: 'F', index: 1 },
  { short: 'Mar', long: 'Marzo', cell: 'G', index: 2 },
  { short: 'Abr', long: 'Abril', cell: 'H', index: 3 },
  { short: 'May', long: 'Mayo', cell: 'I', index: 4 },
  { short: 'Jun', long: 'Junio', cell: 'J', index: 5 },
  { short: 'Jul', long: 'Julio', cell: 'K', index: 6 },
  { short: 'Ago', long: 'Agosto', cell: 'L', index: 7 },
  { short: 'Sep', long: 'Septiembre', cell: 'M', index: 8 },
  { short: 'Oct', long: 'Octubre', cell: 'N', index: 9 },
  { short: 'Nov', long: 'Noviembre', cell: 'O', index: 10 },
  { short: 'Dic', long: 'Diciembre', cell: 'P', index: 11 },
];
